var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:{badge:true, 'badge-pill':true, 'badge-primary': _vm.typ == 'thc','badge-success':_vm.typ == 'cbd'}},[_vm._v(_vm._s(_vm.to1dp(_vm.amount).toLocaleString())+"mg "+_vm._s(_vm.typ.toUpperCase()))])
}
var staticRenderFns = []

export { render, staticRenderFns }